'use client';

import { useEffect } from 'react';

import type { AreaResponse } from '@/src/lib/api';
import { useSetCurrentArea } from '@/src/lib/hooks/query';

type Props = {
  area: AreaResponse;
};

/**
 * Seeds the shared "current area" cache from the server-resolved SRP area so
 * client-only consumers like HeaderNav do not need their own blocking SSR fetch.
 */
export function CurrentAreaHydrator({ area }: Props) {
  const setCurrentArea = useSetCurrentArea();

  useEffect(() => {
    setCurrentArea(area);
  }, [area, setCurrentArea]);

  return null;
}
